import { generateUUID } from "../../shared/services/utils";

export interface Bq8MooringM {
  mooringRopes: MooringRopeDetailsM[];
  mooringWinches: MooringWinchDetailsM[];
  mooringBollards: MooringBollardsDetailsM[];
  mooringFairleads: MooringFairleadsDetailsM[];
}

export interface MooringRopeDetailsM {
  id: string;
  ropeId: string;
  type: string;
  locationIdentity: string;
  material: string;
  diameterSize: string;
  length: string;
  ldbfTonnes: string;
  tdbfTonnes: string;
  swlTonnes: string;
  wllTonnes: string;
  certificateNo: string;
  installedDate: string;
  reversedDate: string;
  renewalDate: string;
  statusLineTail: string;
  conditionLineTail: string;
}

export interface MooringWinchDetailsM {
  id: string;
  winchId: string;
  mooringWinchLocation: string;
  splitDrum: string;
  motivePower: string;
  remoteControls: string;
  heavingPower: string;
  haulingSpeed: string;
  typeOfBrake: string;
  designedBrakeLoad: string;
  operationalBrakeLoad: string;
  dateLastBrakeTest: string;
  brakeRenderingLoad: string;
  brakeTestingFrequency: string;
}

export interface MooringBollardsDetailsM {
  id: string;
  bollardId: string;
  location: string;
  identityNo: string;
  certificateNo: string;
  sizeMm: string;
  swl: string;
  modifications: string;
}

export interface MooringFairleadsDetailsM {
  id: string;
  fairleadId: string;
  type: string;
  location: string;
  identityNo: string;
  certificateNo: string;
  sizeMm: string;
  swl: string;
  modifications: string;
  modificationsClassApproved: string;
}

export const initialBq8Mooring: Bq8MooringM = {
  mooringRopes: [
    {
      id: "",
      ropeId: generateUUID(),
      type: "",
      locationIdentity: "",
      material: "",
      diameterSize: "",
      length: "",
      ldbfTonnes: "",
      tdbfTonnes: "",
      swlTonnes: "",
      wllTonnes: "",
      certificateNo: "",
      installedDate: "",
      reversedDate: "",
      renewalDate: "",
      statusLineTail: "",
      conditionLineTail: "",
    },
  ],
  mooringWinches: [
    {
      id: "",
      winchId: generateUUID(),
      mooringWinchLocation: "",
      splitDrum: "",
      motivePower: "",
      remoteControls: "",
      heavingPower: "",
      haulingSpeed: "",
      typeOfBrake: "",
      designedBrakeLoad: "",
      operationalBrakeLoad: "",
      dateLastBrakeTest: "",
      brakeRenderingLoad: "",
      brakeTestingFrequency: "",
    },
  ],
  mooringBollards: [
    {
      id: "",
      bollardId: generateUUID(),
      location: "",
      identityNo: "",
      certificateNo: "",
      sizeMm: "",
      swl: "",
      modifications: "",
    },
  ],
  mooringFairleads: [
    {
      id: "",
      fairleadId: generateUUID(),
      type: "",
      location: "",
      identityNo: "",
      certificateNo: "",
      sizeMm: "",
      swl: "",
      modifications: "",
      modificationsClassApproved: "",
    },
  ],
};

export function mapSqlToBq8MooringForm(
  mooringRopes: any[],
  mooringFairleads: any[],
  mooringBollards: any[],
  mooringWinches: any[],
): Bq8MooringM {
  return {
    mooringRopes: mooringRopes.map((rope) => ({
      id: rope.ID || "",
      ropeId: rope.ROPE_ID || "",
      type: rope.TYPE || "",
      locationIdentity: rope.LOCATION_IDENTITY || "",
      material: rope.MATERIAL || "",
      diameterSize: rope.DIAMETER_SIZE || "",
      length: rope.LENGTH || "",
      ldbfTonnes: rope.LDBF_TONNES || "",
      tdbfTonnes: rope.TDBF_TONNES || "",
      swlTonnes: rope.SWL_TONNES || "",
      wllTonnes: rope.WLL_TONNES || "",
      certificateNo: rope.CERTIFICATE_NO || "",
      installedDate: rope.INSTALLED_DATE || "",
      reversedDate: rope.REVERSED_DATE || "",
      renewalDate: rope.RENEWAL_DATE || "",
      statusLineTail: rope.STATUS_LINE_TAIL || "",
      conditionLineTail: rope.CONDITION_LINE_TAIL || "",
    })),
    mooringWinches: mooringWinches.map((winch) => ({
      id: winch.ID || "",
      winchId: winch.WINCH_ID || "",
      mooringWinchLocation: winch.LOCATION || "",
      splitDrum: winch.SPLIT_DRUM || "",
      motivePower: winch.MOTIVE_POWER || "",
      remoteControls: winch.REMOTE_CONTROLS || "",
      heavingPower: winch.HEAVING_POWER || "",
      haulingSpeed: winch.HAULING_SPEED || "",
      typeOfBrake: winch.TYPE_OF_BRAKE || "",
      designedBrakeLoad: winch.DESIGNED_BRAKE_LOAD || "",
      operationalBrakeLoad: winch.OPERATIONAL_BRAKE_LOAD || "",
      dateLastBrakeTest: winch.DATE_LAST_BRAKE_TEST || "",
      brakeRenderingLoad: winch.BRAKE_RENDERING_LOAD || "",
      brakeTestingFrequency: winch.BRAKE_TESTING_FREQUENCY || "",
    })),
    mooringBollards: mooringBollards.map((bollard) => ({
      id: bollard.ID || "",
      bollardId: bollard.BOLLARD_ID || "",
      location: bollard.LOCATION || "",
      identityNo: bollard.IDENTITY_NO || "",
      certificateNo: bollard.CERTIFICATE_NO || "",
      sizeMm: bollard.SIZE_MM || "",
      swl: bollard.SWL || "",
      modifications: bollard.MODIFICATIONS || "",
    })),
    mooringFairleads: mooringFairleads.map((fairlead) => ({
      id: fairlead.ID || "",
      fairleadId: fairlead.FAIRLEAD_ID || "",
      type: fairlead.TYPE || "",
      location: fairlead.LOCATION || "",
      identityNo: fairlead.IDENTITY_NO || "",
      certificateNo: fairlead.CERTIFICATE_NO || "",
      sizeMm: fairlead.SIZE_MM || "",
      swl: fairlead.SWL || "",
      modifications: fairlead.MODIFICATIONS || "",
      modificationsClassApproved: fairlead.MODIFICATIONS_CLASS_APPROVED || "",
    })),
  };
}
